'use client'

import { EmptyImage } from 'product-card/components/shared/ProductImage/EmptyImage/EmptyImage'
import { PdpImageLinkWrapper } from 'product-card/components/shared/ProductImage/PdpImageLinkWrapper/PdpImageLinkWrapper'
import { SingleProductImage } from 'product-card/components/shared/ProductImage/SingleProductImage/SingleProductImage'
import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardImpression } from 'product-card/hooks/useProductCardImpression/useProductCardImpression'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { useSortedProductImages } from 'product-card/hooks/useSortedProductImages/useSortedProductImages'
import { ImageDisplayType, type ProductCardBaseProps } from 'product-card/types'
import { useRef } from 'react'

export const OverviewProductCard = ({ className }: ProductCardBaseProps) => {
	const productCardRef = useRef<HTMLDivElement | null>(null)

	const { dataTestId } = useProductCard()
	const showAsFeatured = useShowAsFeatured()

	useProductCardImpression({ productCardRef, shouldSendPrice: false })

	const [firstImage] = useSortedProductImages()

	return (
		<div ref={productCardRef} className={className} data-testid={dataTestId}>
			{/* Render the first image if available, otherwise render a link wrapper */}
			{firstImage ? (
				<SingleProductImage image={firstImage} />
			) : (
				<PdpImageLinkWrapper
					imageDisplayType={ImageDisplayType.Single}
					isSEORelevant
				>
					<EmptyImage isTwoColumnSize={showAsFeatured} />
				</PdpImageLinkWrapper>
			)}
		</div>
	)
}
